/// <reference path="../../_ext/editors/ItemGridEditor.ts" />

namespace TabAurous.Inventory {

    import fld = BranchOutItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class BranchOutItemsEditor extends _Ext.ItemGridEditor<BranchOutItemsRow> {
        protected getColumnsKey() { return "Inventory.BranchOutItems"; }
        protected getDialogType() { return BranchOutItemsDialog; }
        protected getLocalTextPrefix() { return BranchOutItemsRow.localTextPrefix; }

        protected form: BranchOutItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};
        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = true;
            return opt;
        }
        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public TransDate: Date;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = true;
        private contractTotals: string;
        public TotalItems: number;
        public ProductTypeId: number;
        statement: string;
        private Master;
        static baseitemcheck: number;
        //validate pieces and weight on new creation
        public pieces = [];
        public weight = [];
        public itemids = [];
        public isUpdate: number;
        public canUpdate: number;
        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as BranchOutDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                }
            })
        }


        public setEditValue(source: BranchOutRow, property) {

            //super.setOwnerEntity(source);
            this.Master = source;
            super.setEditValue(source, property);
        }
        setMasterValues() {
            this.RateListId = (this.parentDialog as BranchOutDialog).RateListId;
            this.LaborListId = (this.parentDialog as BranchOutDialog).LaborListId;
            this.StoneMarkup = (this.parentDialog as BranchOutDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as BranchOutDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as BranchOutDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as BranchOutDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as BranchOutDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as BranchOutDialog).form.TransDate.valueAsDate;
            this.PartyId = Q.parseInteger((this.parentDialog as BranchOutDialog).form.BranchId.value);
        }

        protected createToolbarExtensions(): void {
            super.createToolbarExtensions(); 

        }

        private getItem(SKU: string) {
            var StockID = [];
            Stock.StockItemService.GetStockTransactions({
                SKU: SKU

            },
                response => StockID = response.Entities,
                {
                    async: false
                });

            var Quantity = 0;
            if (StockID.length > 0) {
                for (var x of StockID) {

                    Quantity += x.Pieces;

                };

                if (Quantity > 0) {
                    var Item = StockID.pop();


                }
            }

        }


        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);
            //Q.first(columns, x => x.field === fld.Discount).format = num;
            Q.first(columns, x => x.field === fld.WstPer).format = num;
            Q.first(columns, x => x.field === fld.Pieces).format = int;
            var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.Weight).format = wt;


            if (BranchOutItemsEditor.baseitemcheck == 2) {
                columns = columns.filter(x => x.field != "SKU" && x.field != "Line_No" && x.field != "DiamondWeight" &&
                    x.field != "StoneWeight" && x.field != "OtherWeight" && x.field != "UnitLabour" &&
                    x.field != "NetWeight" && x.field != "WstWt" && x.field != "WstPer");

            }
            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor
        //**** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            //To Set Master Product Image
            BranchOutDialog.image = item.ImageName;
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item);
                        this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);
                        //}

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            if (target.hasClass('edit numeric')) {
                e.preventDefault();

                if (target.hasClass('edit numeric')) {
                    // var x = Q.coalesce(Q.trimToNull(input.val()), '0');
                    //TODO: Need to add System Parameter to enable disable blocking
                    var input = $(e.target);
                    if (input != undefined) {
                        if (this.canUpdate == 0) {
                            //Check Editable
                            target.addClass('readonly');
                            target.blur();
                            Q.alert("Readonly Detected")

                        }
                        else if (this.canUpdate == 1) {
                            target.removeClass('readonly');
                            var input = $(e.target);
                            var y = input.data();
                            if (y.field == "Weight" && item.ItemTypeId == 101) {
                                target.addClass('readonly');
                                target.blur();
                            }
                            else if (y.field == "Pieces" && item.ItemTypeId == 104) {
                                target.addClass('readonly');
                                target.blur();
                            }
                        }
                    }

                    this.view.refresh();
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject, ) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }
            var oldvalues: Stock.StockItemRow;

            Stock.StockItemService.GetProductDetails({
                ProductId: item.ProductId,
                Line_No: item.Line_No,
                SKU: item.SKU,
                LotNo: item.LotNo,
                TransId: item.TransId,
                TransItemId: item.TransItemId
            },
                response =>
                    oldvalues = response.Entity,
                { async: false });

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {
                var oldpieces = 0;

                oldpieces = oldvalues.Pieces;
                
                if (value > oldpieces) {
                    Q.alert('Invalid Pieces value');
                    item[field] = oldpieces;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {

                var oldweight = 0.0;
                oldweight = oldvalues.Weight;

                if (value > oldweight) {
                    Q.alert('Invalid Weight value');
                    item[field] = oldweight;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }


                if (item.CalcOnId == 4 || item.CalcOnId == 5) {
                    item.GrossAmount = item.UnitRate * value;
                    item.NetAmount = item.UnitRate * value;

                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as BranchOutDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Common.StockSelectGrid;

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                hotkey: "Alt+K",
                onClick: () => { 

                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;

                    }
                    else {

                        var filters: _Ext.SelectGridFilters = {

                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });

                        var ItemDetails = ItemGridHelper.SetTransferItemGrid(selectedItems2, new Date(), this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup);
                        for (let item of ItemDetails) {
                            var labors = item.LaborDetails;
                            if (labors.length > 0)
                                for (var i = 0; i < labors.length; i++) {
                                    delete labors[i].TransactionId;
                                }
                            item.LaborDetails = labors;
                        }
                        this.setData(ItemDetails);
                    }
                    // #endregion

                    pickerDialog.dialogOpen();
                }
            });

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            return buttons;
        }



        // #endregion

        // #region Set Data

        setData(ItemDetails: any[]) {
            if (this.view.getItems().length > 0) {
                this.TotalItems = ItemDetails.length + this.view.getItems().length;
            }
            else {
                this.TotalItems = ItemDetails.length;
            }
            for (let Itemdetail of ItemDetails) {
                Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(Itemdetail);
            }
        }

        // #endregion


    }
}